<template>
  <div class="blog-header">
    <!-- Optional badge/tag at top -->
    <div v-if="badge" class="blog-badge">
      <vue-feather
        v-if="badgeIcon"
        :type="badgeIcon"
        size="12"
        class="badge-icon"
      />
      <span>{{ badge }}</span>
    </div>

    <!-- Date and reading time -->
    <div class="blog-meta-top">
      <span class="blog-date">{{ formattedDate }}</span>
      <span v-if="readingTime" class="blog-reading-time">
        {{ readingTime }} min read
      </span>
    </div>

    <!-- Main title -->
    <h1 class="blog-title">{{ title }}</h1>

    <!-- Optional subheading -->
    <h2 v-if="subheading" class="blog-subheading">{{ subheading }}</h2>

    <!-- Hero image -->
    <div v-if="heroImage" class="blog-hero-image">
      <img :src="heroImage" alt="Blog hero image" class="hero-image" />
    </div>

    <!-- Author info -->
    <div class="blog-meta-bottom">
      <!-- <div class="author-info">
        <img
          :src="authorAvatar || '/blog_assets/logo.png'"
          class="author-avatar"
          :alt="`${author} avatar`"
        />
        <span class="author-name">{{ author || "Skyhost Team" }}</span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "BlogHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      default: "Skyhost Team",
    },
    authorAvatar: {
      type: String,
      default: "/blog_assets/logo_light.png",
    },
    subheading: {
      type: String,
      default: null,
    },
    readingTime: {
      type: [Number, String],
      default: null,
    },
    heroImage: {
      type: String,
      default: null,
    },
    badge: {
      type: String,
      default: null,
    },
    badgeIcon: {
      type: String,
      default: null,
    },
  },
  computed: {
    formattedDate() {
      // Format date to "6 days ago" style or keep original format
      // For now, return as-is. Can be enhanced with date formatting
      return this.date;
    },
  },
};
</script>

<style scoped>
.blog-header {
  margin-bottom: 3rem;
}

.blog-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.8rem;
  margin-bottom: 1rem;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
}

.badge-icon {
  color: #fbbf24;
  width: 12px;
  height: 12px;
}

.blog-meta-top {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-size: 0.875rem;
  color: #666;
}

.blog-date {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.blog-reading-time {
  color: #999;
}

.blog-reading-time::before {
  content: "·";
  margin: 0 0.5rem;
}

.blog-title {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-size: 4rem;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.04em;
  margin: 0.5rem 0 1rem 0;
  color: #000;
}

.blog-subheading {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.01em;
  margin: 0 0 1.5rem 0;
  color: #333;
}

.blog-meta-bottom {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.author-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e0e0e0;
  padding: 0.25rem;
}

.author-name {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  font-weight: 500;
  font-size: 0.95rem;
  color: #333;
}

@media (max-width: 768px) {
  .blog-title {
    font-size: 2.25rem;
    line-height: 1.15;
    letter-spacing: -0.03em;
  }

  .blog-subheading {
    font-size: 1.25rem;
    line-height: 1.35;
  }

  .blog-meta-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .blog-reading-time::before {
    display: none;
  }
}

.blog-hero-image {
  margin-bottom: 2rem;
  border-radius: 8px;
  overflow: hidden;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height: 500px;
  border-radius: 8px;
}
</style>
